import type React from 'react';

// CSS Anchor Positioning is not yet in the TS 4.9 lib types
export type AnchorCSSProperties = React.CSSProperties & { anchorName?: string; positionAnchor?: string };

// Popover API is not yet in the TS 4.9 lib types
export const hidePopover = (el: Nullable<HTMLElement>): void => {
	(el as HTMLElement & { hidePopover?: () => void })?.hidePopover?.();
};
